var _g, _path, _g2, _path2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.87,
    height: 70.315,
    viewBox: "0 0 107.87 70.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_475",
    "data-name": "Groupe 475",
    transform: "translate(0 38.36)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Mon_",
    "data-name": "Mon ",
    transform: "translate(0 14)",
    fill: "#2f6ab9",
    fontSize: 14,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mon ")), /*#__PURE__*/React.createElement("text", {
    id: "Sp\\xE9cialiste_Auto",
    "data-name": "Sp\\xE9cialiste Auto",
    transform: "translate(0 26.955)",
    fill: "#2f6ab9",
    fontSize: 14,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sp\xE9cialiste "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.014em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "uto")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_304",
    "data-name": "Trac\\xE9 304",
    d: "M39.545,68.678,59.2,88.287,78.814,68.678V107.9H72.342V84.464L59.2,97.553,39.545,77.8Z",
    transform: "translate(-37.508 -68.678)",
    fill: "#2f6ab9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_476",
    "data-name": "Groupe 476",
    transform: "translate(68.714 0.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_305",
    "data-name": "Trac\\xE9 305",
    d: "M202.936,108.448h8.012l-19.577-39.6-19.578,39.6h8.074L191.37,84Z",
    transform: "translate(-171.792 -68.848)",
    fill: "#2f6ab9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_306",
    "data-name": "Trac\\xE9 306",
    d: "M44.25,125.924l-6.553,0-.015-20.5,6.55,6.269Z",
    transform: "translate(-36.584 -86.9)",
    fill: "#2f6ab9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_477",
    "data-name": "Groupe 477",
    transform: "translate(43.081 0.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_307",
    "data-name": "Trac\\xE9 307",
    d: "M156.146,77.962l5.27-2.9a12.45,12.45,0,0,0-4.918-5.825L151.634,74.1A7.338,7.338,0,0,1,156.146,77.962Z",
    transform: "translate(-136.164 -69.239)",
    fill: "#2f6ab9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_308",
    "data-name": "Trac\\xE9 308",
    d: "M134.71,96.468a16.9,16.9,0,0,1-4.639-2.275l-4.358,4.358a25.289,25.289,0,0,0,8.315,4.466c3.269,1.1,6.928,2.84,6.928,6.317,0,4.115-3.659,6.085-7.221,6.027-3.123-.116-6-2.84-7.319-5.563l-5.464,3.013c2.342,5.158,7.075,9.156,12.784,9.156,7.465,0,13.369-4.694,13.369-12.343S141,98.786,134.71,96.468Z",
    transform: "translate(-120.951 -81.612)",
    fill: "#2f6ab9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.041804b13d5a223f0f4360bbe7286e1a.svg";
export { ForwardRef as ReactComponent };